module.exports = __webpack_public_path__ + "img/Professor_Desktop@1x.d9210a6.webp";